import { FC, useEffect, useState } from "react";
import NcModal from "shared/NcModal/NcModal";
import RenderSidebar from "./RenderSidebar";
import { Tab } from "@headlessui/react";
import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import Textarea from "shared/Textarea/Textarea";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { Plan } from "containers/PageSubcription/type";
import { Formatter } from "../../utils/formatters";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { useMetadataUser } from "contexts/metadata-user-context";


interface RenderMainrProps {
  planDetails?: Plan;
  formik?: any;
  infoCardFocus: string;
  handleInputFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  handleError?: any;
}

const RenderMain: FC<RenderMainrProps> = ({
  formik, infoCardFocus, planDetails, handleInputFocus, handleError
}) => {
  const { profile } = useMetadataUser();
  const [isProfile, setIsProfile] = useState(false);

  const tomorrowTwoMonths = () => {
    const today = new Date();
    const twoMonths = new Date(today.setMonth(today.getMonth() + 2));
    const twoDays = new Date(twoMonths.setDate(twoMonths.getDate() + 1));
    return Formatter.prettyDate(twoDays);
  }

  useEffect(() => {
    if (profile) {
      setIsProfile(true);
    }
  }, [profile]);

  return (
    <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8">
      <h2 className="text-3xl lg:text-4xl font-semibold">
        Confirme dados para pagamento
      </h2>
      <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
      <div>
        <div>
          <NcModal
            renderTrigger={(openModal) => (
              <span
                onClick={() => openModal()}
                className="block lg:hidden underline  mt-1 cursor-pointer"
              >
                Ver informações do plano
              </span>
            )}
            renderContent={() => {
              return <RenderSidebar
                infoCardFocus={infoCardFocus}
                formik={formik}
                planDetails={planDetails} />;
            }
            }
            modalTitle="Detalhes do plano"
          />
        </div>
      </div>
      <div>
        <div className="space-y-5 -mt-7">
          {isProfile && !profile?.company && (
            <div className="bg-blue/20 border-dashed border-blue rounded-md p-4 border-2">
              <div className="flex items-center justify-center gap-4">
                <AiOutlineInfoCircle className="h-7 w-7" />
                <p className="italic">
                  {`Logo após a sua assinatura, você já poderá fazer reservas com data de check-in a partir de ${tomorrowTwoMonths()}`}
                </p>
              </div>
            </div>
          )}
          <h3 className="text-2xl font-semibold">Pagamento</h3>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700 my-5"></div>

        <div className="mt-6">
          <Tab.Group>
            <Tab.Panels>
              <Tab.Panel className="space-y-5">
                <div className="space-y-1">
                  <Label>Número do cartão </Label>
                  <Input
                    className={handleError("number", formik)}
                    value={formik.values.number}
                    onChange={(e) => {
                      const formattedNumber = Formatter.prettyNumberCredit(
                        e.target.value
                      );
                      formik.handleChange({
                        target: {
                          name: "number",
                          value: formattedNumber,
                        },
                      });
                    }}
                    onBlur={formik.handleBlur}
                    onFocus={handleInputFocus}
                    name="number"
                    placeholder="Número do cartão"
                    id="number-cart"
                    type="text"
                  />
                  {formik.errors.number && formik.touched.number && (
                    <span className="text-[#d32f2f] mt-2 mr-4 mb-0 ml-3 text-left text-xs">
                      {formik.errors.number}
                    </span>
                  )}
                </div>
                <div className="space-y-1">
                  <Label>Nome do titular </Label>
                  <Input
                    className={handleError("name", formik)}
                    name="name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onFocus={handleInputFocus}
                    id="name-cart"
                    placeholder="Nome do titular"
                    type="text"
                  />
                  {formik.errors.name && formik.touched.name && (
                    <span className="text-[#d32f2f] mt-2 mr-4 mb-0 ml-3 text-left text-xs">
                      {formik.errors.name}
                    </span>
                  )}
                </div>
                <div className="flex space-x-5  ">
                  <div className="flex-1 space-y-1">
                    <Label>Validade </Label>
                    <Input
                      type="text"
                      name="expiry"
                      className={handleError("expiry", formik)}
                      value={formik.values.expiry}
                      onChange={(e) => {
                        const formattedDate = Formatter.prettyValidDateCredit(
                          e.target.value
                        );
                        formik.handleChange({
                          target: {
                            name: "expiry",
                            value: formattedDate,
                          },
                        });
                      }}
                      onBlur={formik.handleBlur}
                      onFocus={handleInputFocus}
                      id="date-cart"
                      placeholder="Validade (mm/aaaa)"
                    />
                    {formik.errors.expiry && formik.touched.expiry && (
                      <span className="text-[#d32f2f] mt-2 mr-4 mb-0 ml-3 text-left text-xs">
                        {formik.errors.expiry}
                      </span>
                    )}
                  </div>
                  <div className="flex-1 space-y-1">
                    <Label>CVC/CVV </Label>
                    <Input
                      name="cvc"
                      id="cvv-cart"
                      className={handleError("cvc", formik)}
                      value={formik.values.cvc}
                      onChange={(e) => {
                        const formattedCVC = Formatter.prettyCVCCredit(
                          e.target.value
                        );
                        formik.handleChange({
                          target: {
                            name: "cvc",
                            value: formattedCVC,
                          },
                        });
                      }}
                      onBlur={formik.handleBlur}
                      onFocus={handleInputFocus}
                      placeholder="CVC/CVV"
                    />
                    {formik.errors.cvc && formik.touched.cvc && (
                      <span className="text-[#d32f2f] mt-2 mr-4 mb-0 ml-3 text-left text-xs">
                        {formik.errors.cvc}
                      </span>
                    )}
                  </div>
                </div>
              </Tab.Panel>
              <Tab.Panel className="space-y-5">
                <div className="space-y-1">
                  <Label>Email </Label>
                  <Input type="email" defaultValue="example@gmail.com" />
                </div>
                <div className="space-y-1">
                  <Label>Password </Label>
                  <Input type="password" defaultValue="***" />
                </div>
                <div className="space-y-1">
                  <Label>Messager for author </Label>
                  <Textarea placeholder="..." />
                  <span className="text-sm text-neutral-500 block">
                    Write a few sentences about yourself.
                  </span>
                </div>
              </Tab.Panel>
            </Tab.Panels>
          </Tab.Group>
          <div className="pt-8">
            <ButtonPrimary
              className="bg-[--blue] hover:bg-[--blue-dark]"
              type="submit"
              onClick={formik.submitForm}
            >
              Confirma pagamento
            </ButtonPrimary>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RenderMain